(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bz-editorial-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bz-editorial-hero')) {
    customElements.define('bz-editorial-hero', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        this.slides = [...this.querySelectorAll('[data-slide]')];
        if (!this.slides.length) return;
        this.index = 0;
        this.dots = [...this.querySelectorAll('[data-go]')];
        this.toggle = this.querySelector('[data-toggle]');
        this.status = this.querySelector('[data-status]');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.dataset.autoplay !== 'true';
        this.initialCycle = true;
        this.hovered = false;
        this.focused = false;
        this.editorSelected = false;
        this.inView = true;
        const on = (target, type, handler, options = {}) => target.addEventListener(type, handler, { ...options, signal: this.abort.signal });
        this.querySelector('.bz-hero__controls')?.removeAttribute('hidden');
        this.dots.forEach(dot => on(dot, 'click', () => this.show(Number(dot.dataset.go), true)));
        const prev = this.querySelector('[data-prev]');
        const next = this.querySelector('[data-next]');
        if (prev) on(prev, 'click', () => this.show(this.index - 1, true));
        if (next) on(next, 'click', () => this.show(this.index + 1, true));
        if (this.toggle) on(this.toggle, 'click', () => { this.paused = !this.paused; this.updateToggle(); this.schedule(); });
        on(this, 'pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); } });
        on(this, 'pointerleave', () => { this.hovered = false; this.schedule(); });
        on(this, 'focusin', () => { this.focused = true; this.schedule(); });
        on(this, 'focusout', event => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); } });
        on(this, 'keydown', event => {
          if (!['ArrowLeft', 'ArrowRight'].includes(event.key) || /INPUT|TEXTAREA|SELECT/.test(event.target.tagName)) return;
          event.preventDefault();
          this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
        });
        this.track = this.querySelector('.bz-hero__slides');
        this.drag = null;
        this.suppressClick = false;

        on(this.track, 'pointerdown', event => {
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          if (event.target.closest('a, button, input, select, textarea, [role="button"]')) return;

          this.drag = {
            id: event.pointerId,
            x: event.clientX,
            y: event.clientY,
            lastX: event.clientX,
            moved: false,
            horizontal: false
          };

          try { this.track.setPointerCapture(event.pointerId); } catch (e) {}
        });

        on(this.track, 'pointermove', event => {
          if (!this.drag || event.pointerId !== this.drag.id) return;

          const dx = event.clientX - this.drag.x;
          const dy = event.clientY - this.drag.y;
          this.drag.lastX = event.clientX;

          if (!this.drag.horizontal && Math.abs(dx) > 8) {
            this.drag.horizontal = Math.abs(dx) > Math.abs(dy) * 1.1;
          }

          if (!this.drag.horizontal) return;

          this.drag.moved = true;
          this.track.classList.add('is-dragging');
          event.preventDefault();
        }, { passive: false });

        on(this.track, 'pointerup', event => {
          if (!this.drag || event.pointerId !== this.drag.id) return;

          const dx = event.clientX - this.drag.x;
          const dy = event.clientY - this.drag.y;
          const shouldRotate = this.drag.moved && Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.2;

          if (this.drag.moved) {
            this.suppressClick = true;
            requestAnimationFrame(() => { this.suppressClick = false; });
          }

          this.track.classList.remove('is-dragging');
          try { this.track.releasePointerCapture(event.pointerId); } catch (e) {}
          this.drag = null;

          if (shouldRotate) this.show(this.index + (dx < 0 ? 1 : -1), true);
        });

        on(this.track, 'pointercancel', event => {
          if (this.drag && event.pointerId === this.drag.id) {
            this.track.classList.remove('is-dragging');
            this.drag = null;
          }
        });

        on(this.track, 'click', event => {
          if (!this.suppressClick) return;
          event.preventDefault();
          event.stopPropagation();
        }, { capture: true });
        on(document, 'visibilitychange', () => this.schedule());
        on(this.motion, 'change', () => { this.updateToggle(); this.schedule(); });
        on(document, 'shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index < 0) return;
          this.editorSelected = true;
          this.show(index, false);
        });
        on(document, 'shopify:block:deselect', event => {
          if (!this.slides.some(slide => slide.dataset.blockId === event.detail.blockId)) return;
          this.editorSelected = false;
          this.schedule();
        });
        this.observer = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; this.schedule(); });
        this.observer.observe(this);
        this.show(0, false);
        this.updateToggle();
      }
      show(index, announce) {
        const next = (index + this.slides.length) % this.slides.length;
        if (announce) this.initialCycle = false;
        const previous = this.slides[this.index];
        if (next !== this.index && previous.contains(document.activeElement)) (this.dots[next] || this.toggle)?.focus({ preventScroll: true });
        const pictureTemplate = this.slides[next].querySelector('template[data-hero-picture]');
        if (pictureTemplate) {
          const picture = pictureTemplate.content.cloneNode(true);
          const image = picture.querySelector('img');
          if (image) image.loading = 'eager';
          pictureTemplate.replaceWith(picture);
        }
        this.index = next;
        this.slides.forEach((slide, i) => {
          const active = i === next;
          slide.classList.toggle('is-active', active);
          slide.toggleAttribute('inert', !active);
          if (active) slide.removeAttribute('aria-hidden');
          else slide.setAttribute('aria-hidden', 'true');
          if (this.dots[i]) {
            if (active) this.dots[i].setAttribute('aria-current', 'true');
            else this.dots[i].removeAttribute('aria-current');
          }
        });
        this.style.setProperty('--hero-controls-color', getComputedStyle(this.slides[next]).color);
        const counter = this.querySelector('[data-current]');
        if (counter) counter.textContent = String(next + 1).padStart(2, '0');
        if (announce && this.status) this.status.textContent = `${next + 1} / ${this.slides.length}: ${this.slides[next].querySelector('h2')?.textContent || ''}`;
        this.schedule();
      }
      updateToggle() {
        if (!this.toggle) return;
        const paused = this.paused || this.motion.matches;
        this.toggle.disabled = this.motion.matches;
        this.toggle.setAttribute('aria-label', this.motion.matches ? this.dataset.reducedLabel : paused ? this.dataset.playLabel : this.dataset.pauseLabel);
        this.toggle.querySelector('[data-play-icon]').toggleAttribute('hidden', !paused);
        this.toggle.querySelector('[data-pause-icon]').toggleAttribute('hidden', paused);
      }
      schedule() {
        clearTimeout(this.timer);
        if (this.slides.length < 2 || this.paused || this.motion.matches || this.hovered || this.focused || this.editorSelected || document.hidden || !this.inView) return;
        const interval = Number(this.dataset.interval) || 5000;
        const initialDelay = Math.max(Number(this.dataset.initialDelay) || 10000, interval);
        this.timer = setTimeout(() => {
          this.initialCycle = false;
          this.show(this.index + 1, false);
        }, this.initialCycle ? initialDelay : interval);
      }
      disconnectedCallback() { clearTimeout(this.timer); this.abort?.abort(); this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
